
<p-tabView *ngIf="!nenhuma">
  <p-tabPanel header="Ativas">
      <p-accordion>
        <p-accordionTab *ngFor="let li of licitacoes" [header]="(li.dia | dataMomento)+' - '+li.descricao">
            <app-lista-arquivos [categoria]="'licitacaoNova'+li.id"></app-lista-arquivos>
        </p-accordionTab>
      
      </p-accordion>
    
  </p-tabPanel>

  <p-tabPanel header="Encerradas">
    <p-accordion>
      <p-accordionTab *ngFor="let li of passadas" [header]="(li.dia | dataMomento)+' - '+li.descricao">
        <app-lista-arquivos [categoria]="'licitacaoNova'+li.id"></app-lista-arquivos>
      </p-accordionTab>
    
    </p-accordion>
  </p-tabPanel>

  </p-tabView>

  <section *ngIf="nenhuma" class="vazio">
    <div style="text-align: center;" class="caixa">
      <i class="fa fa-info" aria-hidden="true"></i>
      <div>
        Nenhum Documento publicado.
      </div>
    </div>
  </section>

  